import React from "react";

import { MinimalLayout } from "theme/layouts";
import { useRoutes } from "react-router-dom";

import { APP_CONSTANTS } from "../config/appConstants";
import NotFoundPage from "../../theme/pages/NotFoundPage";
import RedirectHandler
	from "../../core/components/redirectHandler/RedirectHandler";

const Routes = () => {
	const routes = useRoutes([
		{
			path: "/",
			element: <MinimalLayout />,
			children: [
				{
					path: "/verifikation/email",
					element: <RedirectHandler />
				},
				{
					path: APP_CONSTANTS.URL.HOME,
					element: <RedirectHandler />
				},
				{
					path: "*",
					element: <NotFoundPage />
				}
			]
		}
	]);

	return routes;
};

export default Routes;
